import styled from 'styled-components';

export const Block = styled.div`
  margin-top: 16px;
  padding: 12px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #f8fafc;
`;

export const Title = styled.div`
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #64748b;
  margin-bottom: 8px;
`;

export const Rows = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 92px 120px 1fr;
  align-items: baseline;
  gap: 10px;
  font-size: 13px;
`;

export const When = styled.span`
  color: #475569;
  white-space: nowrap;
`;

export const Amount = styled.span<{ negative: boolean }>`
  font-variant-numeric: tabular-nums;
  font-weight: 600;
  text-align: right;
  color: ${({ negative }) => (negative ? '#b91c1c' : '#166534')};
`;

export const Where = styled.span`
  color: #334155;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Note = styled.div`
  font-size: 13px;
  color: #334155;
  line-height: 1.5;
`;

export const Muted = styled.div`
  font-size: 13px;
  color: #5b6775;
  line-height: 1.5;
`;
